import { pinResetEquipmentPortTypeConfig } from '../constants/pinResetConfig';

export const getPinResetEquipment = equipmentDetails => {
	let pinResetEquipment = null;

	if (equipmentDetails) {
		equipmentDetails.forEach(equipment => {
			const currentPortType = equipment.get('currentPortType');

			if (pinResetEquipmentPortTypeConfig.includes(currentPortType && currentPortType.trim().toUpperCase())
			) {
				pinResetEquipment = equipment;
			}
		});
	}

	return pinResetEquipment;
};



// WEBPACK FOOTER //
// ./src/utils/pinResetUtils.js